import { useContext } from 'react';
import AuthContext, { AuthContextValue } from '../contexts/Auth0Context';

const useAuth = (): AuthContextValue => useContext(AuthContext);

export default useAuth;
